import React from 'react';
import { View, TouchableOpacity, ActivityIndicator } from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

export const Button = ({
	label,
	labelStyle,
	icon,
	style,

	secondary,
	flat,
	disabled,

	loading,

	onPress,
}) => {
	const styles = useThemedStyles(createStyles);
	return (
		<TouchableOpacity
			accessibilityRole="button"
			accessibilityState={{ disabled: Boolean(disabled), busy: Boolean(loading) }}
			style={[
				styles.button,
				secondary && styles.secondary,
				flat && styles.flatButton,
				disabled && styles.disabled,
				style,
			]}
			disabled={disabled}
			onPress={loading ? () => null : onPress}
		>

			{
				loading ? <ActivityIndicator size="small" color={styles.activityIndicator.color} /> : (
					<View style={styles.content}>
						{ icon && (
							<View style={styles.icon}>
								{icon}
							</View>
						)}

						<Text style={[
							styles.label,
							secondary && styles.secondaryLabel,
							flat && styles.flatLabel,
							disabled && styles.disabledLabel,
							labelStyle,
						]}>
							{label}
						</Text>
					</View>
				)
			}

		</TouchableOpacity>
	);
};

// Default = outlined pill, secondary = filled primary, flat = quiet tonal.
// minHeight keeps a 44 pt touch target while screens can still set a height.
const createStyles = ({ ui: { colors, radius, touch, type, space } }) => ({
	button: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: radius.pill,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
		marginBottom: 1,
		marginTop: 1,
		paddingHorizontal: space.lg,
		paddingVertical: space.xs,
		minHeight: touch.min,
	},
	flatButton: {
		backgroundColor: colors.chip,
		borderColor: colors.chip,
	},
	// flexShrink lets a label longer than the button wrap instead of spilling past its edges.
	content: {
		flexDirection: 'row',
		alignItems: 'center',
		flexShrink: 1,
	},
	icon: {
		marginRight: 8,
	},
	label: {
		...type.bodySmallStrong,
		flexShrink: 1,
		color: colors.onChip,
		textAlign: 'center',
	},
	flatLabel: {
		color: colors.onChip,
	},
	activityIndicator: {
		color: colors.accent,
	},
	secondary: {
		backgroundColor: colors.primary,
		borderColor: colors.primary,
	},
	// The outline keeps a disabled button visible where disabledBg matches the card (Light);
	// the opacity fades it so it never reads as an available button.
	disabled: {
		backgroundColor: colors.disabledBg,
		borderColor: colors.borderStrong,
		opacity: 0.5,
	},
	secondaryLabel: {
		color: colors.onPrimary,
	},
	disabledLabel: {
		color: colors.disabledText,
	},
});
